import { ENV } from '~/common/enums/enums';
import { SeoPayload } from '~/common/types/types';

const seoPayload: SeoPayload = {
  title: 'seo.codex.title',
  description: 'seo.codex.description',
  siteUrl: ENV.APP.URL,
};

export { seoPayload };
